function removerMascaraTelefone(telefone) {

    if (!telefone) { return ""; }


    return telefone.replace(/[^0-9]+/g, "");
}

export default removerMascaraTelefone;